import { secureGet } from "config/encryption_decryption/get_post_encryptDecrypt";

export const getReferral = async (panelListId: number, page: number) => {
  return secureGet("/api/survey/getMyReferralUsers", { panelListId, page });
};

export const getRedeemRequestHistoryData = async (panelistId: number, page: number) => {
  return secureGet("/api/survey/getZampliaSurveysClaimRequest", { panelistId, page, requestType: "Referral Wallet", panel: "ZampliaSurveys" });
};